<template>
  <div class="relative w-16 h-16">
    <svg class="transform -rotate-90" viewBox="0 0 100 100">
      <!-- Background circle (gray) -->
      <circle
        class="text-gray-200"
        stroke-width="20"
        stroke="currentColor"
        fill="transparent"
        :r="props.radius"
        cx="50"
        cy="50"
      />
      <!-- Progress circle (blue) -->
      <circle
        class="filled-circle"
        stroke-width="20"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="dashOffset"
        stroke="currentColor"
        fill="transparent"
        :r="props.radius"
        cx="50"
        cy="50"
      />
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  radius: {
    type: Number,
    required: false,
    default: 38
  },
  timeLeft: {
    type: Number,
    required: true
  },
  totalTime: {
    type: Number,
    required: true
  }
})

const circumference = computed(() => 2 * Math.PI * props.radius) // 2πr where r=40
const dashOffset = computed(() => {
  const progress = props.timeLeft / props.totalTime
  return -circumference.value * (progress)
})
</script> 

<style scoped>
.filled-circle {
  color: var(--primary);
}
</style>


